export enum SettingsSdkKeys {
    currencyCode = "next.ecommerce.currencyCode",
    direction = "next.ecommerce.direction",
    fullTerritoryName = "next.ecommerce.fullTerritoryName",
    realm = "next.ecommerce.realmName",
    territory = "next.ecommerce.territoryName",
    language = "next.ecommerce.languageName",
    languageId = "next.ecommerce.header.alternativeLanguages",
    correlationHeaderName = "x-next-correlation-id",
    appCache = "next.ecommerce.header.frontend.appCacheTTL",
    cacheControl = "next.ecommerce.header.frontend.cache-control.max-age",
    cacheControlDefault = "next.ecommerce.header.frontend.cache-control.default-header.max-age",
    featureSwitch = "next.ecommerce.header.frontend.featureSwitch",
    style = "next.ecommerce.header.frontend.style",
    countrySelectorVersion = "next.ecommerce.header.frontend.countrySelectorVersion",
    defaultDataVersion = "next.ecommerce.header.frontend.defaultDataVersion",
    geolocationVersion = "next.ecommerce.header.frontend.geolocationVersion",
    monetateSDK = "next.ecommerce.header.frontend.monetateSDK",
    bloomreachGroupLocation = "next.ecommerce.header.frontend.bloomreachGroupLocation",
    bloomreachViewId = "next.ecommerce.header.frontend.bloomreachViewId",
    widescreenCookieConsent = "next.ecommerce.header.frontend.widescreenCookieConsent",
    showBackToSiteBanner = "next.ecommerce.header.frontend.showBackToSiteBanner",
    backToSite = "next.ecommerce.header.frontend.backToSite",
    imagePlaceHolder = "next.ecommerce.header.frontend.ImagePlaceholder",
    secondaryMeganavCacheControl = "next.ecommerce.header.frontend.cache-control.secondary-meganav.max-age",
    defaultPrimaryConfig = "next.ecommerce.header.frontend.defaultPrimaryConfig",
    defaultSecondaryConfig = "next.ecommerce.header.frontend.defaultSecondaryConfig",
    bloomreachCookieFullDomain = "next.ecommerce.header.frontend.bloomreachCookieFullDomain",
    useBloomreachSegmentCookie = "next.ecommerce.header.frontend.useBloomreachSegmentCookie",
    showTestTools = "next.ecommerce.header.frontend.showTestTools",
}

export interface SettingsModel {
    realm: string
    alignment: string
    territory: string
    language: string
    favourites: boolean
}
